import { withdrawApplication } from '@yeshuman/sdk'
import { useState } from 'react'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { toast } from 'sonner'


type UseWithdrawApplicationOptions = {
  applicationId: string | undefined
  onWithdrawn?: () => void
}

export function useWithdrawApplication({
  applicationId,
  onWithdrawn,
}: UseWithdrawApplicationOptions) {
  const queryClient = useQueryClient()
  const [open, setOpen] = useState(false)

  const mutation = useMutation({
    mutationFn: async () => {
      if (!applicationId) {
        throw new Error('Application not found')
      }
      await withdrawApplication(applicationId)
    },
    onSuccess: () => {
      toast.success('Application withdrawn')
      setOpen(false)
      void queryClient.invalidateQueries({ queryKey: ['my-applications'] })
      void queryClient.invalidateQueries({ queryKey: ['application', 'my', applicationId] })
      onWithdrawn?.()
    },
    onError: (error: Error) => {
      toast.error(error.message || 'Could not withdraw application')
    },
  })

  const isPending = mutation.isPending

  return {
    openDialog: () => setOpen(true),
    isPending,
    dialogProps: {
      open,
      onOpenChange: (next: boolean) => {
        if (isPending && !next) return
        setOpen(next)
      },
      onConfirm: () => mutation.mutate(),
      isPending,
    },
  }
}
